@if (isCollapsed) {
    <div class="ai-section">
        <button mat-button (click)="openAi()" class="">
            <div class="w-100 d-flex flex-row justify-content-between align-items-center">
                <mat-icon class="ai-icon">auto_awesome</mat-icon>
            </div>
        </button>
    </div>
} @else {
    <div class="ai-section">
        <mat-card class="ai-card" (click)="openAi($event)">
            <mat-card-content class="ai-card-content card">
                <div class="ai-content">
                    <span class="ai-title">{{ 'menu.sideCards.ai.title' | transloco }}</span>
                    <span class="ai-subtitle">{{ 'menu.sideCards.ai.subtitle' | transloco }}</span>
                </div>

                <div class="d-flex flex-row mt-2">
                    <button mat-stroked-button (click)="openAi($event)" class="ai-button">
                        <div class="w-100 d-flex flex-row justify-content-between align-items-center">
                            <mat-icon class="mr-1">auto_awesome</mat-icon>
                            <div>
                                <span class="ai-text ms-1">{{ 'menu.sideCards.ai.button' | transloco }}</span>
                            </div>
                        </div>
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
}
